exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-box[data-v-f2767782]{position:relative;text-align:left}.edit-button[data-v-f2767782]{position:absolute;top:calc(50% - 14px);right:3%;width:100px;text-align:right}.edit-input[data-v-f2767782]{width:70%;text-align:left}", ""]);

// exports
